import { updatePost } from "../../api/historyService";

export const useUpdatePost = (successCallback) => {
  const update = async (id, data) => {
    try {
        const updatedRecord = await updatePost(id, data);
        if (successCallback) successCallback(updatedRecord);
        return updatedRecord;
    } catch (error) {
        console.error("Failed to update post:", error);
        throw error;
    }
  };

  return { update };
};